export default __webpack_public_path__ + "static/amritanshu-e116c10c55ab8bae5b5036c0594d5ac3.webp";